import React from 'react';
import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {Button} from 'components';
import {AlertModal} from 'components/modals';

const InterestedInHrModal = observer(({uiState}) => {
  return (
    <AlertModal
      size='sm'
      header='hr_upgrade.learn_more.Great!'
      body='hr_upgrade.learn_more.Our HR team has been notified and will contact you shortly.'
      isOpen={uiState.interestedInHrModalOpen}
      onHide={() => uiState.closeInterestedInHrModal()}
    >
      <Button className='right' onClick={() => uiState.closeInterestedInHrModal()}>
        <FormattedMessage id='hr_upgrade.learn_more.Got it!'/>
      </Button>
    </AlertModal>
  );
});

export default InterestedInHrModal;
